import {
  LedgerTransactionsAction,
  Trace,
  TraceActionClient,
  Transaction,
} from 'lib/apiClient'

interface MappedTransactionsData {
  clientId: string
  transactions: Transaction[]
}

export function mapTransactionsData(data?: {
  traces: Trace[]
}): MappedTransactionsData | null {
  if (!data) {
    return null
  }

  let ledgerTransactions: LedgerTransactionsAction | undefined

  for (const trace of data.traces) {
    if (trace.client === TraceActionClient.LedgerTransactionsClient) {
      ledgerTransactions = trace
      break
    }
  }

  if (!ledgerTransactions || !ledgerTransactions.clientOutput.transactions?.length) {
    return null
  }

  return {
    clientId: ledgerTransactions.clientInput.clientId,
    transactions: ledgerTransactions.clientOutput.transactions.map(t => t.data),
  }
}
